import {
  postAuthenticate,
  postRequestOtp,
  postVerifyOtp,
  postLogin,
  postLoginWithGoogle,
  postLoginWithApple,
  // postValidateToken, // REMOVED - function no longer exists
  postLogout,
  postRequestCode,
} from '../services/api/requests/Login'

import {
  encodeSSOData,
  saveSSOData,
  isClientVerified,
  deleteSSOVerification,
  getRedirectUri,
  getSSOData,
  getCredentials,
} from '../services/data/sso.js'
import { REQUEST_OTP, VERIFY_OTP } from '../services/data/loginSteps.json'
import { PREFERENCES } from '../services/data/registrationSteps.json'

import {
  setGAUserId,
  setGAEvent,
  setGACustomEvent,
} from '../services/analytics/google-analytics'
import { doGetAccountStatus } from './Profile'
import { getSelectedPreferences } from '../services/api/requests/Preferences'

export const doHandleSSORedirection = async (
  searchString,
  redirectToThirdParty,
  accessToken,
  nativeRedirect,
) => {
  if (searchString && redirectToThirdParty) {
    let thisCode = undefined
    const { redirectUri, responseType, clientId } = await getCredentials(
      searchString,
    )

    if (responseType === 'code' && accessToken && clientId) {
      thisCode = await doRequestSSOCode({ accessToken, clientId })
    }

    await redirectToThirdParty(redirectUri, thisCode)
  } else if (!!nativeRedirect) {
    await nativeRedirect()
  }
}

export const doAuthenticate = ({
  replace,
  setLoginStep,
  setAuthRequestData,
  setLoginRequestId,
  searchString,
  setRegisterNumber,
}) => async (values, state) => {
  const { username: mobile } = values

  state.setStatus({})
  state.setSubmitting(true)
  try {
    const { clientId } = getCredentials(searchString)
    const response = await postAuthenticate({ mobile, clientId })
    const requestData = response.data
    setAuthRequestData({ ...requestData, mobile })
    setLoginStep(REQUEST_OTP)
    setGACustomEvent('button_cta', {
      screen_name: 'Login',
      button_name: 'Continue with Mobile Number',
    })

    doRequestOtp({ setLoginStep, setLoginRequestId, replace, searchString })(
      values,
      state,
    )
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}
    if (status === 404) {
      // mobile number not yet registered
      setRegisterNumber && setRegisterNumber(mobile)
      state.setSubmitting(false)
      setGACustomEvent('screen_view', {
        screen_name: 'Registration - Native Registration Popup',
      })
      return
    }

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}

export const doRequestOtp = ({
  setLoginStep,
  setLoginRequestId,
  replace,
  searchString,
}) => async (values, state) => {
  const { username: mobile } = values

  state.setStatus({})
  try {
    const { clientId } = getCredentials(searchString)
    const response = await postRequestOtp({ mobile, clientId })
    const requestData = response.data
    if (requestData.status === 'sent') setLoginRequestId(requestData.requestId)
    setLoginStep(VERIFY_OTP)
    if (searchString) replace(`/login/otp${searchString}`)
    else replace(`/login/otp`)
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
}

export const doVerifyOtp = ({
  replace,
  setStep,
  searchString,
  setLoginStep,
  loginRequestId,
  setPrimaryInfo,
  setAccessToken,
  saveAccessToken,
  setPreferenceIds,
  setLoyaltyPoints,
  setAccountStatus,
  redirectAfterAuth,
  setAuthRequestData,
  redirectToThirdParty,
  setFirstSpinModalOpen,
  firebaseMessagingToken,
  doSubscribeToFirebaseMessaging,
}) => async (values, state) => {
  const { code } = values

  state.setStatus({})
  state.setSubmitting(true)

  if (searchString && !isClientVerified()) {
    state.setStatus({
      error: 'Client not verified.',
    })

    return
  }

  try {
    const response = await postVerifyOtp(
      { loginRequestId, code },
      firebaseMessagingToken,
    )
    const {
      accessToken,
      expiresIn,
      refreshToken,
      refreshExpiresIn,
      user,
    } = response.data
    const token = encodeSSOData({
      accessToken,
      expiresIn,
      refreshToken,
      refreshExpiresIn,
    })

    //analytics
    setGAUserId(accessToken)
    setGAEvent('user_login', 'login', 'native_username_pass')

    //native
    setPrimaryInfo(user)
    setLoyaltyPoints({})
    setAccessToken(accessToken)
    saveAccessToken(accessToken)
    setFirstSpinModalOpen(true)

    // ST-3178
    await doGetAccountStatus({
      accessToken,
      setAccountStatus,
    })

    //firebase
    doSubscribeToFirebaseMessaging({
      firebaseMessagingToken,
    })()

    //sso
    saveSSOData(token)
    deleteSSOVerification()
    //sso redirection
    if (searchString && getRedirectUri(searchString)) {
      await doHandleSSORedirection(
        searchString,
        redirectToThirdParty,
        accessToken,
      )
    }

    //preference redirection
    if (user.preference) {
      setLoginStep(0)

      // ST-3117 get preferences and save in primary info
      const preferencesResponse = await getSelectedPreferences(accessToken)
      const preferenceIds =
        (preferencesResponse &&
          preferencesResponse.data &&
          preferencesResponse.data.ids) ||
        []
      setPreferenceIds(preferenceIds)

      replace(redirectAfterAuth || '/')
    } else {
      setStep(PREFERENCES)
      replace('/register/preferences')
    }
    setAuthRequestData(null)
    localStorage.removeItem('popup-index')
  } catch (error) {
    console.log('verifyOTP catch error: ', error)
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error while Verifying OTP' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}

export const doVerifyToken = async accessToken => {
  // REMOVED - postValidateToken function no longer exists
  // state.setStatus({})
  // try {
  //   const response = await postValidateToken(accessToken)
  //   return response.status === 200
  // } catch (error) {
  return false
  // const { data = {}, status } = error.response || {}
  // const { message = 'Network Error' } = data || {}

  // state.setStatus({
  //   status,
  //   error: message,
  // })
  // }
}

export const doRequestSSOCode = async ({ accessToken, clientId }) => {
  try {
    const { data } = await postRequestCode({ accessToken, clientId })
    return (data && data.code) || false
  } catch (error) {
    return false
  }
}

export const doPostLogout = async () => {
  const token = await getSSOData()
  if (token) {
    const { accessToken, refreshToken } = token
    await postLogout({ accessToken, refreshToken })
  }
}

export const doGoogleLogin = ({
  setPrimaryInfo,
  setLoyaltyPoints,
  replace,
  setStep,
  saveAccessToken,
  setAccessToken,
  setGoogleToken,
  redirectAfterAuth,
  firebaseMessagingToken,
  doSubscribeToFirebaseMessaging,
  setPerformingSocialAuth,
  registration,
  redirectToThirdParty,
  searchString,
}) => async gResponse => {
  setPerformingSocialAuth(true)
  setGACustomEvent('button_cta', {
    screen_name: 'Login',
    button_name: 'Continue with Google',
  })

  const response = await postLoginWithGoogle({
    token: gResponse.access_token,
    fcmToken: firebaseMessagingToken,
  })

  const { status, data } = response
  const { accessToken, expiresIn, refreshToken, refreshExpiresIn, user } = data
  const token = encodeSSOData({
    accessToken,
    expiresIn,
    refreshToken,
    refreshExpiresIn,
  })

  if (status === 200) {
    //analytics
    setGAUserId(accessToken)
    setGAEvent('user_login', 'login', 'google')

    if (registration)
      setGAEvent('button_cta', 'Registration', 'Continue with Google')
    else setGAEvent('button_cta', 'Login ', 'Continue with Google')

    //native
    setAccessToken(accessToken)
    setPrimaryInfo(user)
    setLoyaltyPoints({})

    //sso
    saveSSOData(token)
    deleteSSOVerification()

    //firebase
    doSubscribeToFirebaseMessaging({
      firebaseMessagingToken,
    })()

    //sso redirection
    if (!registration && searchString && getRedirectUri(searchString)) {
      saveAccessToken(accessToken)
      await localStorage.removeItem('popup-index')
      await doHandleSSORedirection(
        searchString,
        redirectToThirdParty,
        accessToken,
      )
    }

    //preference redirection
    if (user.preference) {
      saveAccessToken(accessToken)
      replace(redirectAfterAuth || '/')
    } else {
      setStep(PREFERENCES)
      replace('/register/preferences')
    }

    return
  }

  setGoogleToken(gResponse.access_token)

  setPrimaryInfo(data)
  setLoyaltyPoints({})
  if (searchString) replace(`/register${searchString}`)
  else replace('/register')
  setPerformingSocialAuth(false)
}

export const doAppleLogin = ({
  setPrimaryInfo,
  setLoyaltyPoints,
  replace,
  setStep,
  saveAccessToken,
  setAccessToken,
  setAppleToken,
  redirectAfterAuth,
  firebaseMessagingToken,
  doSubscribeToFirebaseMessaging,
  setPerformingSocialAuth,
  registration,
  redirectToThirdParty,
  searchString,
}) => async aResponse => {
  setPerformingSocialAuth(true)

  const response = await postLoginWithApple({
    token: aResponse.authorization.id_token,
    code: aResponse.authorization.code,
    fcmToken: firebaseMessagingToken,
  })

  if (aResponse.user && typeof window !== 'undefined' && window.localStorage) {
    localStorage.setItem('siwaData', JSON.stringify(aResponse.user))
  }

  const { status, data } = response
  const { accessToken, expiresIn, refreshToken, refreshExpiresIn, user } = data
  const token = encodeSSOData({
    accessToken,
    expiresIn,
    refreshToken,
    refreshExpiresIn,
  })

  if (status === 200) {
    //analytics
    setGAUserId(data.accessToken)
    setGAEvent('user_login', 'login', 'apple')
    if (registration)
      setGAEvent('button_cta', 'Registration', 'Continue with Apple')
    else setGAEvent('button_cta', 'Login ', 'Continue with Apple')

    //native
    setAccessToken(accessToken)
    setPrimaryInfo(user)
    setLoyaltyPoints({})

    //firebase
    doSubscribeToFirebaseMessaging({
      firebaseMessagingToken,
    })()

    //sso
    saveSSOData(token)
    deleteSSOVerification()

    //sso redirection
    if (!registration && searchString && getRedirectUri(searchString)) {
      saveAccessToken(accessToken)
      await localStorage.removeItem('popup-index')
      await doHandleSSORedirection(
        searchString,
        redirectToThirdParty,
        accessToken,
      )
    }

    //preference redirection
    if (user.preference) {
      saveAccessToken(accessToken)
      replace(redirectAfterAuth || '/')
    } else {
      setStep(PREFERENCES)
      replace('/register/preferences')
    }
    localStorage.removeItem('popup-index')
    return
  }

  setAppleToken(aResponse.accessToken)

  setPrimaryInfo(data)
  setLoyaltyPoints({})

  if (searchString) replace(`/register${searchString}`)
  else replace('/register')
  setPerformingSocialAuth(false)
}

// Legacy Code: Not used by web anymore ====
export const doLogin = ({
  replace,
  setPrimaryInfo,
  setAccessToken,
  saveAccessToken,
  setLoyaltyPoints,
  setStep,
  redirectAfterAuth,
  firebaseMessagingToken,
  doSubscribeToFirebaseMessaging,
}) => async (values, state) => {
  const { username, password } = values

  state.setStatus({})
  state.setSubmitting(true)
  try {
    const response = await postLogin(
      { username, password },
      firebaseMessagingToken,
    )
    const { accessToken } = response.data

    setGAUserId(accessToken)
    setGAEvent('user_login', 'login', 'native_username_pass')

    setPrimaryInfo(response.data.user)
    setLoyaltyPoints({})
    setAccessToken(response.data.accessToken)
    doSubscribeToFirebaseMessaging({
      firebaseMessagingToken,
    })()
    if (response.data.user.preference) {
      saveAccessToken(response.data.accessToken)
      replace(redirectAfterAuth || '/')
    } else {
      setStep(PREFERENCES)
      replace('/register/preferences')
    }
    localStorage.removeItem('popup-index')
  } catch (error) {
    const { data = {}, status } = error.response || {}
    const { message = 'Network Error' } = data || {}

    state.setStatus({
      status,
      error: message,
    })
  }
  state.setSubmitting(false)
}
// Legacy Code: Not used by web anymore ====
